import React, { Fragment, useRef } from "react";
import { Module, SolidDivider, Box } from "@thecb/components";
import { Container } from "reactstrap";
import CommonHeader from "./subcomponents/common-header";
import CommonDetails from "./subcomponents/common-details";
import PartialRefundContainer from "./subcomponents/refund-container/PartialRefundContainer";
import PaymentDetails from "./subcomponents/payment-details";
import TransactionDetails from "./subcomponents/transaction-details";
import AlertBar from "@/components/alert-bar";
import RefundHistory from "./subcomponents/refund-history/RefundHistory";

const Payment = ({
  fetchRequestPending,
  payment,
  paymentIsLoaded,
  userTimezone,
  getServiceTypeText,
  goToPayment,
  linkedTransactions,
  getDescriptionKeys,
  getSubdescriptionKeys,
  refundRequestPending,
  voidRequestPending,
  openPartialRefundContainer,
  closePartialRefundContainer,
  setPartialRefundLineItem,
  toggleRefundWindow,
  toggleRefundAllLineItems,
  openVoidRefundModal,
  closeVoidRefundModal,
  submitVoidRefundModal,
  partialRefundContainerOpen,
  partialRefundItems,
  voidRefundModalOpen,
  refundWindows,
  userRole,
  downloadReceipt,
  receiptDownloadPending,
  alertBars,
  actions,
}) => {
  const {
    alertBars: { paymentPageAlertBar: paymentPageAlertBarAction },
  } = actions;
  const { paymentPageAlertBar } = alertBars;
  const refundsRef = useRef(null);

  return (
    <Fragment>
      {!fetchRequestPending && paymentIsLoaded && (
        <Container>
          {paymentPageAlertBar.alerts.length > 0 && (
            <Box padding="1rem 0">
              <AlertBar {...paymentPageAlertBar} {...paymentPageAlertBarAction} />
            </Box>
          )}
          <Module>
            <CommonHeader payment={payment} />
            <SolidDivider />
            <CommonDetails
              payment={payment}
              linkedTransactions={linkedTransactions}
              userTimezone={userTimezone}
              refundRequestPending={refundRequestPending}
              voidRequestPending={voidRequestPending}
              openVoidRefundModal={openVoidRefundModal}
              openPartialRefundContainer={openPartialRefundContainer}
              closeVoidRefundModal={closeVoidRefundModal}
              submitVoidRefundModal={submitVoidRefundModal}
              voidRefundModalOpen={voidRefundModalOpen}
              goToPayment={goToPayment}
              userRole={userRole}
              refundsRef={refundsRef}
              downloadReceipt={downloadReceipt}
              receiptDownloadPending={receiptDownloadPending}
            />
            {partialRefundContainerOpen && (
              <Fragment>
                <SolidDivider />
                <PartialRefundContainer
                  payment={payment}
                  closePartialRefundContainer={closePartialRefundContainer}
                  partialRefundItems={partialRefundItems}
                  setPartialRefundLineItem={setPartialRefundLineItem}
                  toggleRefundAllLineItems={toggleRefundAllLineItems}
                  refundRequestPending={refundRequestPending}
                  submitVoidRefundModal={submitVoidRefundModal}
                  goToPayment={goToPayment}
                  getDescriptionKeys={getDescriptionKeys}
                  getSubdescriptionKeys={getSubdescriptionKeys}
                />
              </Fragment>
            )}
          </Module>
          <TransactionDetails
            payment={payment}
            userTimezone={userTimezone}
            getServiceTypeText={getServiceTypeText}
            getDescriptionKeys={getDescriptionKeys}
            getSubdescriptionKeys={getSubdescriptionKeys}
          />
          <PaymentDetails payment={payment} />
          <RefundHistory
            refundsRef={refundsRef}
            payment={payment}
            goToPayment={goToPayment}
            userTimezone={userTimezone}
            refundWindows={refundWindows}
            toggleRefundWindow={toggleRefundWindow}
            getDescriptionKeys={getDescriptionKeys}
            getSubdescriptionKeys={getSubdescriptionKeys}
          />
        </Container>
      )}
    </Fragment>
  );
};

export default Payment;
